import { render, staticRenderFns } from "./stripeOrPayPalModal.vue?vue&type=template&id=01a23dc2&scoped=true&"
import script from "./stripeOrPayPalModal.vue?vue&type=script&lang=js&"
export * from "./stripeOrPayPalModal.vue?vue&type=script&lang=js&"
import style0 from "./stripeOrPayPalModal.vue?vue&type=style&index=0&id=01a23dc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a23dc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VContainer,VDialog,VImg,VSpacer})
